'use strict'
const isMobile = require('./lib/strLib').isMobile

module.exports = {
  confirm: (obj, msg, title, type, confirmCallback, cancelCallback) => {
    obj
      .$alert(msg, title, {
        showCancelButton: true,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: type,
      })
      .then(confirmCallback)
      .catch(cancelCallback)
  },
  inputEmail: (obj, msg, title, inputType, invalidMsg, confirmCallback, cancelCallback) => {
    obj
      .$prompt(msg, title, {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        inputType: inputType,
        inputPattern:
          /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: invalidMsg,
      })
      .then(confirmCallback)
      .catch(cancelCallback)
  },
  inputPassword: (obj, msg, title, inputType, invalidMsg, confirmCallback, cancelCallback) => {
    obj
      .$prompt(msg, title, {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        dangerouslyUseHTMLString: true,
        inputType: inputType,
        inputErrorMessage: invalidMsg,
      })
      .then(confirmCallback)
      .catch(cancelCallback)
  },
  inputString: (obj, msg, title, inputType, inputPlaceholder, invalidMsg, confirmCallback, cancelCallback) => {
    obj
      .$prompt(msg, title, {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        dangerouslyUseHTMLString: true,
        inputType: inputType,
        inputPlaceholder: inputPlaceholder,
        inputErrorMessage: invalidMsg,
      })
      .then(confirmCallback)
      .catch(cancelCallback)
  },
  notify(obj, title, msg, type = 'success', duration = 3000) {
    obj.$notify({
      title: title,
      message: `<div style="word-break: break-all;">${msg}</div>`,
      type: type,
      dangerouslyUseHTMLString: true,
      duration: duration,
    })
  },

  notify0(obj, title, msg, type = 'success', isNoti) {
    obj.$notify({
      title: title,
      message: `<div style="word-break: break-all;">${msg}</div>`,
      type: type,
      dangerouslyUseHTMLString: true,
      duration: 0,
      onClose: isNoti,
    })
  },
  base64Encoding(obj) {
    return Buffer.from(JSON.stringify(obj), 'utf-8').toString('base64')
  },

  base64Decoding(str) {
    return JSON.parse(Buffer.from(str, 'base64').toString('utf-8'))
  },

  async copy(url) {
    if (isMobile()) {
      try {
        await navigator.share({ url })
        return true
      } catch (err) {
        if (err.name === 'AbortError') return true
        return false
      }
    } else {
      try {
        await navigator.clipboard.writeText(url)
        return true
      } catch (err) {
        return false
      } finally {
        // Remove the selections - NOTE: Should use
        // removeRange(range) when it is supported
        // window.getSelection().removeAllRanges()
      }
    }
  },
  getSessionId() {
    let sessionId = sessionStorage.getItem('sessionId')
    if (!sessionId || sessionId === undefined || sessionId === null) {
      let random = self.crypto.getRandomValues(new Uint32Array(3))
      let tempId = ''
      for (let item of random) {
        tempId += item
      }
      sessionId = 'SI:' + tempId
      sessionStorage.setItem('sessionId', sessionId)
    }
    return sessionId
  },

  sendDataWithEnter(e, args, callbackFnc) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      callbackFnc(args)
    }
  },
}
